import { computed } from 'vue'
import { rawDynamicImport } from '@app/helpers/memberships/section'

export default function(validate, form){
    return {
        title     : 'Confirmation',
        component : rawDynamicImport(() => import('@app/booking/components/form/stages/confirmation/Confirmation.vue')),
        isValid   : computed(
            () => validate({
                confirms_details: ['required', 'checked']
            })
        ),
        data: computed(
            () => ({
                confirms_details  : form.value.confirms_details,
                marketing_consent : form.value.marketing_consent
            })
        ),
    }
}